import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardHeader, CardTitle, CardBody, FormGroup, Input, Button, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import useGlobal from "store";

const GlobalBudget = (props) => {

    const [response, actions] = useGlobal(
        state => state.response,
        actions => actions
    );

    useEffect(() => {

    }, [response]);

    const [monthlyBudget, setMonthlyBudget] = useState(props.monthlyBudget || 0);

    const handleMonthlyBudgetChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        setMonthlyBudget(value);

    }

    const saveMonthlyBudget = () => {
        let data = {
            id: props.userId,
            monthly_budget: monthlyBudget
        }
        console.log('UPDATING USER', data);
        actions.userActions.updateUser(data);
        actions.notifierActions.notify('Monthly Budget Updated', 'success', 'br');
    }

    return (<>
        <Card>
            <CardHeader>
                <CardTitle tag="h4">Set a monthly limit for your account</CardTitle>
            </CardHeader>
            <CardBody>
                <p>Receive a notification when you reach this amount in a given month. If you don’t want any notifications, you can leave it blank or set to $0.</p>
                
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" name="monthly_budget" onChange={handleMonthlyBudgetChange} value={monthlyBudget} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Button className="m-0" color="primary" onClick={() => saveMonthlyBudget()}>SAVE</Button>
                            </FormGroup>
                        </Col>
                    </Row>
                
            </CardBody>
        </Card>
    </>);

}
export default GlobalBudget;

